<template>
  <div style="background-color: #F8F9FB;">
    <hhead></hhead>
    <crm-nav :val="count"></crm-nav>
    <div class="team_box">
      <div
        class="team"
        :style="{
          minHeight: MHeight,
          boxSizing: 'border-box',
          padding: '25px 30px',
        }"
      >
        <div class="titleBox">
          <span>
            基本信息
          </span>
        </div>
        <ul class="gsMsg">
          <div class="left">
            <li>
              <span class="iconfont icon-lingxing"></span>公司名称：{{
                res.name
              }}
            </li>
            <li>
              <span class="iconfont icon-lingxing"></span>成立时间：{{
                res.createDate | renderTime
              }}
            </li>

            <li>
              <span class="iconfont icon-lingxing"></span>注册资本：{{
                res.initMoney
              }}
            </li>
            <li>
              <span class="iconfont icon-lingxing"></span>社会信用代码：{{
                res.code
              }}
            </li>
          </div>
          <div>
            <li style="display: flex;">
              <span class="iconfont icon-lingxing"
                >&nbsp;&nbsp;
                <i style="color: #181e2d;font-size: 18px;">社会信用执照</i>
                :&nbsp;&nbsp;&nbsp;</span
              >
              <div style="float: left;" class="demo-image__preview">
                <el-image
                  style="max-width: 150px; max-height: 230px"
                  :src="res ? this.$store.state.api + res.codePic : ''"
                  :preview-src-list="res[this.$store.state.api + res.codePic]"
                >
                </el-image>
              </div>
              <!-- <img
                style="width:160px;height:160px;position:absolute;"
                :src="this.$store.state.api + res.codePic"
                alt=""
              /> -->
            </li>
          </div>

          <!-- 上传logo -->
          <!-- <div v-if="res.entLogo">
            <li>
              <span class="iconfont icon-lingxing"></span
              >logo:&nbsp;&nbsp;&nbsp;
              <img
                style="width:160px;height:160px;position:absolute;"
                :src="this.$store.state.api + res.entLogo"
                alt=""
              />
            </li>
          </div> -->

          <div style="display: flex;padding-top: 7px;font-size: 18px;">
            <span
              style="line-height: 24px;"
              class="iconfont icon-lingxing"
            ></span
            >logo:&nbsp;&nbsp;&nbsp;
            <li style="margin-bottom: 20px;position: relative;height: 160px;">
              <el-upload
                class="avatar-uploader"
                :action="this.$store.state.api + '/ad/upload/upload_file'"
                :show-file-list="false"
                name="file"
                accept="image/png, image/jpeg"
                :on-success="handleAvatarSuccess"
              >
                <img
                  v-if="res.entLogo"
                  alt="加载失败"
                  style="width: 160px;height: 160px;object-fit: cover;"
                  :src="this.$store.state.api + res.entLogo"
                  class="avatar"
                />
                <i
                  v-else
                  style="color: #dcdfe6;width: 160px;height: 160px;line-height: 160px; border: 1px dashed #dcdfe6;"
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
                <i
                  class="el-icon-camera"
                  style="border-radius: 50%;display: block;background-color: #5B85FF;width: 28px;height: 28px;
                      text-align: center;line-height: 28px;font-size: 17px;color: #fff;
                      position: absolute;bottom: 0;right: -15px;border: 1px solid #fff;
                      "
                ></i>
              </el-upload>
            </li>
          </div>
        </ul>

        <div class="titleBox">
          <span>
            投资范围
          </span>
          <p>
            <i
              v-if="edit2"
              @click="edit2 = !edit2"
              class="iconfont icon-bianji"
            ></i>
            <i v-if="edit2" @click="edit2 = !edit2" class="decoration">修改</i>
            <i v-if="!edit2" @click="saveBtn" class="iconfont icon-baocun "></i>
            <i v-if="!edit2" @click="saveBtn" class="decoration">保存</i>
          </p>
        </div>
        <p v-if="edit2" class="text_a">
          {{ res.bizArea }}
        </p>
        <div v-else class="textareaBox">
          <el-input type="textarea" rows="3" v-model="res.bizArea"> </el-input>
        </div>

        <div class="titleBox">
          <span>
            投资理念
          </span>
          <p>
            <i
              v-if="edit"
              @click="edit = !edit"
              class="iconfont icon-bianji"
            ></i>
            <i v-if="edit" @click="edit = !edit" class="decoration">修改</i>
            <i v-if="!edit" @click="saveBtn" class="iconfont icon-baocun "></i>
            <i v-if="!edit" @click="saveBtn" class="decoration">保存</i>
          </p>
        </div>
        <p v-if="edit" class="text_a">
          {{ res.bizDirection }}
        </p>
        <div v-else class="textareaBox">
          <el-input type="textarea" rows="3" v-model="res.bizDirection">
          </el-input>
        </div>

        <div class="titleBox">
          <span>
            投资策略
          </span>
          <p>
            <i
              v-if="edit1"
              @click="edit1 = !edit1"
              class="iconfont icon-bianji"
            ></i>
            <i v-if="edit1" @click="edit1 = !edit1" class="decoration">修改</i>
            <i v-if="!edit1" @click="saveBtn" class="iconfont icon-baocun "></i>
            <i v-if="!edit1" @click="saveBtn" class="decoration">保存</i>
          </p>
        </div>
        <p v-if="edit1" class="text_a">
          {{ res.bizStrategy }}
        </p>
        <div v-else class="textareaBox">
          <el-input type="textarea" rows="3" v-model="res.bizStrategy">
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from '../header/index';
import crmNav from '../../../components/crmNav/index';
import './style.css';

export default {
  components: { hhead, crmNav },
  data() {
    return {
      count: 1,
      MHeight: document.documentElement.clientHeight - 94 + 'px',
      res: '',
      edit: true,
      edit1: true,
      edit2: true,
      imageUrl: '',
      imgPath: '',
    };
  },
  filters: {
    renderTime: function(date) {
      if (date) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, ' ')
          .replace(/\.[\d]{3}Z/, '')
          .substr(0, 11);
      }
    },
  },
  mounted() {
    this.msg();
  },
  methods: {
    msg() {
      this.$axios
        .post('/crm/ent/getAuthInfo', {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200 || res.data.code == 403) {
            this.res = res.data.data;
          }
        });
    },
    handleAvatarSuccess(res, file) {
      //上传logo
      // console.log(res);
      if (res.code == 200) {
        // this.$message.success(res.message);
        this.imageUrl = URL.createObjectURL(file.raw);
        this.imgPath = res.data.filePath;
        this.$axios
          .post('/crm/ent/eidt', {
            apiToken: this.$store.state.usermsg.apiToken,
            entLogo: res.data.filePath,
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.msg();
              this.count++;

              //   crmNav.methods.getAuthInfo();
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$message.error(res.message);
      }
    },
    saveBtn() {
      this.$axios
        .post('/crm/ent/eidt', {
          apiToken: this.$store.state.usermsg.apiToken,
          bizDirection: this.res.bizDirection,
          bizStrategy: this.res.bizStrategy,
          bizArea: this.res.bizArea,
        })
        .then((res) => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.edit = true;
            this.edit1 = true;
            this.edit2 = true;
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: '确定',
              type: 'error',
              center: true,
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/mechanism/index.vue